import type { StateCreator } from 'zustand';

import type { GenerationSlice } from './types';

export type { GenerationSlice } from './types';

/**
 * Per-card concurrent generation state lives on ContentFile (uuid,
 * generationStartTime, webhookContext, error). The slice keeps only the
 * global flags / recovery mutex / progress fallback.
 */
export const generationInitialState = {
  isGenerating: false,
  isPrimaryActionLoading: false,
  generationProgress: 0,
  generationError: null as string | null,
};

export const createGenerationSlice: StateCreator<
  GenerationSlice,
  [],
  [],
  GenerationSlice
> = (set) => ({
  ...generationInitialState,
  setGenerationProgress: (generationProgress) => set({ generationProgress }),
  setGenerationError: (generationError) => set({ generationError }),
});
